// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__pJUho","container":"Footer_container__z46Qy","column":"Footer_column__V2CwQ","bottom":"Footer_bottom__WPI3G"};